<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购登记</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主内容容器 -->
    <div class="content-container">
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="店铺">
          <el-select v-model="formInline.shopIds" placeholder="店铺" clearable multiple style="width: 80px;">
            <el-option v-for="shop in shopList" :key="shop.id" :label="shop.shopName" :value="shop.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="formInline.orderSn" placeholder="订单号" clearable style="width: 130px;"></el-input>
        </el-form-item>
        <el-form-item label="平台">
          <dict-select v-model="formInline.erpPlatform" category-id="ERP_PLATFORM" placeholder="请选择平台" clearable style="width: 120px;"></dict-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="formInline.orderStateList" placeholder="订单状态" clearable multiple style="width: 120px;">
            <el-option v-for="status in orderStatusList" :key="status.value" :label="status.label" :value="status.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购途径">
          <dict-select v-model="formInline.purchaseChannel" category-id="PURCHASE_CHANNEL" placeholder="采购途径" style="width: 120px">
          </dict-select>
        </el-form-item>
        <el-form-item label="采购人">
          <user-selector v-model="selectedUsers" :multiple="true" placeholder="请选择采购人" style="width: 120px;" @select="handleUserSelect">
          </user-selector>
        </el-form-item>
        <el-form-item label="采购日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实际利润">
          <el-select v-model="formInline.actualProfitLessThanZero" placeholder="请选择" clearable style="width: 120px;">
            <el-option label="小于 0" value="1"></el-option>
            <el-option label="大于等于 0" value="2"></el-option>
            <el-option label="不为空" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单日期">
          <el-date-picker
            v-model="orderDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading"
        :row-key="getRowKey"
        :expand-row-keys="expandedRows"
        @expand-change="handleExpandChange"
        @sort-change="handleSortChange">

        <el-table-column type="expand">
          <template slot-scope="props">
            <!-- 买家备注显示区域 -->
            <div v-if="props.row.shopeeRemark" style="padding: 10px 20px; background-color: #fff3cd; border-left: 4px solid #ffc107; margin-bottom: 10px;">
              <span style="font-weight: bold; color: #856404;">买家备注：</span>
              <span style="color: #856404;">{{ props.row.shopeeRemark }}</span>
            </div>
            <div class="order-items-section">
              <el-table :data="props.row.orderItems" border style="width: 100%">
                <el-table-column prop="itemImage" label="商品图片" width="150" align="center">
                  <template slot-scope="scope">
                    <img v-if="scope.row.itemImage" :src="scope.row.itemImage"
                         style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px;" />
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="itemName" label="商品名称" min-width="200" show-overflow-tooltip>
                  <template slot-scope="item">
                    <span class="item-name clickable-item-name"
                          @click="copyItemName(item.row.itemName)"
                          :title="'点击复制商品名称: ' + item.row.itemName">
                      {{ item.row.itemName }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="itemModelName" label="规格" min-width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="amount" label="数量" width="90" align="center">
                </el-table-column>
                <dict-table-column prop="purchaseChannel" label="采购途径" align="center" width="120"
                  category-id="PURCHASE_CHANNEL">
                </dict-table-column>
                <el-table-column prop="purchaseAmount" label="采购金额" width="100" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.purchaseAmount > 0 
                        ? scope.row.purchaseAmount.toFixed(2) 
                        : scope.row.purchaseAmount === 0 ? 0 : '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="purchaseDate" label="采购日期" width="120" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.purchaseDate ? scope.row.purchaseDate.substring(0, 10) : '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="purchaseUserName" label="采购人" width="100" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.purchaseUserName || '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="settlementFlag" label="结算状态" width="100" align="center">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.purchaseChannel"> - </span>
                    <el-tag type="info" v-else-if="scope.row.purchaseChannel != 3"> 无需结算 </el-tag>
                    <el-tag v-else :type="scope.row.settlementFlag ? 'success' : 'warning'">
                      {{ scope.row.settlementFlag ? '已结算' : '未结算' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="expressNo" label="快递单号" min-width="150" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.expressNo"
                          class="express-no clickable-express"
                          @click="copyExpressNo(scope.row.expressNo)"
                          :title="'点击复制快递号: ' + scope.row.expressNo">
                      {{ scope.row.expressNo }}
                    </span>
                    <span v-else class="no-express">未填写</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="120" align="center">
                  <template slot-scope="scope">
                    <!-- 采购明细表没有记录、或者只有未结算的 && 是自己创建的，才显示编辑和删除按钮 -->
                    <template v-if="scope.row.settlementFlag == null
                            || scope.row.purchaseUserId === currentUserId  && !scope.row.settlementFlag">
                      <el-button v-permission="['ord-purchase:update']" size="mini" type="text" icon="el-icon-edit" @click="editPurchaseItem(scope.row)">编辑</el-button>
                      <el-button v-permission="['ord-purchase:delete']" size="mini" type="text" icon="el-icon-delete" @click="deletePurchaseItem(scope.row)" style="color: #f56c6c;">删除采购信息</el-button>
                    </template>
                    <span v-else-if="scope.row.purchaseChannel && scope.row.settlementFlag" style="color: #909399;">已结算</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="shopName" label="店铺名称" width="80" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="orderSn" label="订单号" width="160" align="center">
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: bold; cursor: pointer;"
              @click="copyOrderSn(scope.row.orderSn)" :title="'点击复制订单号'">
              {{ scope.row.orderSn }}
            </span>
          </template>
        </el-table-column>
        <dict-table-column prop="erpPlatform" label="平台" category-id="ERP_PLATFORM" width="80" align="center">
        </dict-table-column>
        <dict-table-column prop="orderStates" label="订单状态" category-id="ERP_ORDER_STATUS" width="70" align="center">
        </dict-table-column>
        <el-table-column prop="createTime" label="下单时间" width="140" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="剩余发货时间" width="155" align="center" prop="autoCancel3plAckDate" sortable="custom">
          <template slot-scope="scope">
            <span v-if="scope.row.autoCancel3plAckDate" :style="{ color: isCountdown(scope.row.autoCancel3plAckDate, scope.row.orderStates) ? 'chocolate' : '' }">
              {{ formatShipTime(scope.row.autoCancel3plAckDate, scope.row.orderStates) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalPrice" label="订单总金额" width="80" align="center">
          <template slot-scope="scope">
            <span style="color: #E6A23C; font-weight: bold;">{{ scope.row.totalPrice ? scope.row.totalPrice.toFixed(2) : '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="incomeAmount" label="入账金额" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.row.incomeAmount ? scope.row.incomeAmount.toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="expectWeight" label="预计重量" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.row.expectWeight ? scope.row.expectWeight.toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="totalPurchaseAmount" label="采购总金额" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.row.totalPurchaseAmount > 0 
                ? scope.row.totalPurchaseAmount.toFixed(2) 
                : (scope.row.totalPurchaseAmount == 0 ) ? 0 : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="expectedProfit" label="预计利润" width="100" align="center">
          <template slot-scope="scope">
            <el-popover
              placement="top"
              width="400"
              trigger="hover"
              v-if="canCalculateExpectedProfit(scope.row)">
              <div style="line-height: 1.8;">
                <div style="font-weight: bold; margin-bottom: 8px;">预计利润计算公式：</div>
                <div style="color: #606266;">入账金额 × 台湾提款手续费比例 ÷ 当日汇率 - 预计重量 × 每吨运费 - 贴标费 - 进店费 - 采购总金额 = 预计利润</div>
                <div style="color: #409EFF; margin-top: 4px;">
                  {{ scope.row.incomeAmount || 0 }} × {{ taiwanWithdrawFeeRatio || 1 }} ÷ {{ scope.row.exchangeRate || 1 }} - {{ scope.row.expectWeight || 0 }} × {{ getExpectedUnitFee(scope.row) }} - {{ getExpectedStickFee(scope.row) }} - {{ getExpectedInShopeeFee(scope.row) }} - {{ scope.row.totalPurchaseAmount || 0 }} = {{ calculateExpectedProfit(scope.row).toFixed(2) }}
                </div>
              </div>
              <span slot="reference" :style="{ color: calculateExpectedProfit(scope.row) >= 0 ? '#67C23A' : '#F56C6C', cursor: 'pointer' }">
               ￥ {{ calculateExpectedProfit(scope.row).toFixed(2) }}
              </span>
            </el-popover>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="outTime" label="出库时间" width="140" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.outTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="chargeWeight" label="实际重量" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.row.chargeWeight ? scope.row.chargeWeight.toFixed(1) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="actualShippingFee" label="实际运费" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.row.chargeWeight ? (scope.row.stickFee + scope.row.inShopeeFee + scope.row.unitFee).toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="stickFee" label="贴标费" width="80" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.totalPurchaseAmount === 0">
              <span v-if="scope.row.stickFee != null" style="color: #409EFF; cursor: pointer;" @click="editStickFee(scope.row)">
                {{ scope.row.stickFee.toFixed(2) }}
              </span>
              <el-button v-else type="text" icon="el-icon-edit" style="color: #409EFF;" @click="editStickFee(scope.row)"></el-button>
            </template>
            <span v-else>
              {{ scope.row.stickFee != null ? scope.row.stickFee.toFixed(2) : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="actualProfit" label="实际利润" width="100" align="center">
          <template slot-scope="scope">
            <el-popover
              placement="top"
              width="400"
              trigger="hover"
              v-if="scope.row.stickFee != null || (scope.row.actualProfit !== null && scope.row.actualProfit !== undefined)">
              <div style="line-height: 1.8;">
                <div style="font-weight: bold; margin-bottom: 8px;">实际利润计算公式：</div>
                <div style="color: #606266;">入账金额 × 台湾提款手续费比例 ÷ 当日汇率 - 实际重量 × 每吨运费 - 贴标费 - 进店费 - 采购总金额 = 实际利润</div>
                <div style="color: #409EFF; margin-top: 4px;">
                  {{ scope.row.stickFee != null ? getFrontendActualProfitFormula(scope.row) : getActualProfitFormula(scope.row) }}
                </div>
              </div>
              <span slot="reference" :style="{ color: (scope.row.stickFee != null ? calcFrontendActualProfit(scope.row) : scope.row.actualProfit) >= 0 ? '#67C23A' : '#F56C6C', cursor: 'pointer' }">
                ￥ {{ (scope.row.stickFee != null ? calcFrontendActualProfit(scope.row) : scope.row.actualProfit).toFixed(2) }}
              </span>
            </el-popover>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="实际利润率" width="100" align="center">
          <template slot-scope="scope">
            <el-popover
              placement="top"
              width="500"
              trigger="hover"
              v-if="(scope.row.stickFee != null || (scope.row.actualProfit !== null && scope.row.actualProfit !== undefined)) && scope.row.totalPrice && scope.row.totalPrice > 0 && scope.row.exchangeRate">
              <div style="line-height: 1.8;">
                <div style="font-weight: bold; margin-bottom: 8px;">实际利润率计算公式：</div>
                <div style="color: #606266;">实际利润 ÷ (订单总金额 ÷ 当日汇率) × 100% = 实际利润率</div>
                <div style="color: #409EFF; margin-top: 4px;">
                  {{ (scope.row.stickFee != null ? calcFrontendActualProfit(scope.row) : scope.row.actualProfit).toFixed(2) }} ÷ ({{ scope.row.totalPrice.toFixed(2) }} ÷ {{ scope.row.exchangeRate.toFixed(4) }}) × 100% = {{ calcFrontendActualProfitRate(scope.row).toFixed(2) }}%
                </div>
              </div>
              <span slot="reference" :style="{ color: (scope.row.stickFee != null ? calcFrontendActualProfit(scope.row) : scope.row.actualProfit) >= 0 ? '#67C23A' : '#F56C6C', cursor: 'pointer' }">
                {{ calcFrontendActualProfitRate(scope.row).toFixed(2) }}%
              </span>
            </el-popover>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <!-- 标签列 -->
        <el-table-column label="标签" width="120" align="center">
          <template slot-scope="scope">
            <!-- 有权限时显示可编辑的标签 -->
            <template v-if="hasTagEditPermission">
              <el-popover
                placement="top"
                width="350"
                trigger="hover"
                :ref="`tagPopover_${scope.row.orderSn}`">
                <div class="tag-selector">
                  <div class="tag-section">
                    <div class="tag-section-title">可选标签：</div>
                    <div class="tag-options">
                      <div v-for="option in tagOptions" :key="option.value" style="display: inline-block; margin: 2px;">
                        <dict-tag
                          category-id="SCENE_01_TAG"
                          :value="option.value"
                          :class="{ 'tag-clickable': true, 'tag-available': !isTagSelected(scope.row, option.value) }"
                          @click.native="addTag(scope.row, option.value)"
                          v-if="!isTagSelected(scope.row, option.value)">
                        </dict-tag>
                      </div>
                    </div>
                  </div>
                  <div class="tag-section" v-if="scope.row.tagList && scope.row.tagList.length > 0">
                    <div class="tag-section-title">已选标签：</div>
                    <div class="tag-options">
                      <div v-for="tag in scope.row.tagList" :key="tag.id" style="display: inline-block; margin: 2px;">
                        <dict-tag
                          category-id="SCENE_01_TAG"
                          :value="tag.tag"
                          :class="{ 'tag-clickable': true, 'tag-selected': true }"
                          @click.native="removeTag(scope.row, tag.tag)">
                        </dict-tag>
                      </div>
                    </div>
                  </div>
                </div>
                <div slot="reference" class="tag-display editable-tag-display">
                  <div v-if="scope.row.tagList && scope.row.tagList.length > 0">
                    <div v-for="tag in scope.row.tagList" :key="tag.id" style="margin-bottom: 2px;">
                      <dict-tag category-id="SCENE_01_TAG" :value="tag.tag"></dict-tag>
                    </div>
                  </div>
                  <span v-else>-</span>
                </div>
              </el-popover>
            </template>

            <!-- 无权限时显示只读标签 -->
            <template v-else>
              <div class="tag-display readonly-tag-display">
                <div v-if="scope.row.tagList && scope.row.tagList.length > 0">
                  <div v-for="tag in scope.row.tagList" :key="tag.id" style="margin-bottom: 2px;">
                    <dict-tag category-id="SCENE_01_TAG" :value="tag.tag"></dict-tag>
                  </div>
                </div>
                <span v-else>-</span>
              </div>
            </template>
          </template>
        </el-table-column>
        <!-- 使用NoteColumn组件 -->
        <NoteColumn :current-scene="currentScene" />
        <el-table-column label="操作" min-width="150" align="center">
          <template slot-scope="scope">
            <el-button
              v-permission="['ord-purchase:update']"
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="editPurchase(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="openNotesDrawer(scope.row)" icon="el-icon-tickets">备注</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="empty-table-placeholder">
            <i class="el-icon-warning-outline" style="font-size: 32px; color: #C0C4CC; margin-bottom: 10px;"></i>
            <p>暂无数据</p>
          </div>
        </template>
      </el-table>

      <!-- 分页 -->
      <Pagination v-bind:child-msg="pageParam" @callback_getPageData="callback_getPageData"></Pagination>
    </div>

    <!-- 编辑采购订单对话框 -->
    <OrdPurchaseEdit :visible.sync="purchaseDialogVisible" :editData="currentPurchaseData" :isEdit="isEditPurchase"
      @submit="handlePurchaseSubmit" />

    <!-- 编辑采购明细对话框 -->
    <OrdPurchaseItemEdit :visible.sync="purchaseItemDialogVisible" :editData="currentPurchaseItemData" :isEdit="isEditPurchaseItem"
      @submit="handlePurchaseItemSubmit" />

    <!-- 编辑贴标费对话框 -->
    <OrdPurchaseStickFeeEdit :visible.sync="stickFeeDialogVisible" :editData="currentStickFeeData"
      @submit="handleStickFeeSubmit" />

    <!-- 备注抽屉 -->
    <el-drawer
      title="订单备注"
      :visible.sync="notesDrawerVisible"
      direction="rtl"
      size="600px"
      :before-close="handleDrawerClose">
      <div style="padding: 20px;">
        <OrderNotesDrawer
          :notes="currentOrderNotes"
          :orderSn="currentOrderSn"
          :currentScene="currentScene"
          :showDebug="false"
          @note-updated="handleNoteUpdated" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getOrdPurchasePage, deleteOrdPurchaseItem } from '../../api/OrdPurchase'
import { getAllEnabledShops } from '../../api/SysShop'
import { getOrderStates } from '../../api/ErpOrder'
import { sysParamGet } from '../../api/SysParam'
import { getByOrderSnAndScene } from '../../api/WkbNote'
import { updateOrderTags } from '../../api/WkbTag'
import { dictCategoryItems } from '../../api/SysDictItem'
import Pagination from '../../components/Pagination'
import DictSelect from '../../components/DictSelect'
import DictTableColumn from '../../components/DictTableColumn'
import DictTag from '../../components/DictTag'
import UserSelector from '../../components/UserSelector'
import NoteColumn from '../../components/NoteColumn'
import OrderNotesDrawer from './OrderNotesDrawer'
import OrdPurchaseEdit from './OrdPurchaseEdit'
import OrdPurchaseItemEdit from './OrdPurchaseItemEdit'
import OrdPurchaseStickFeeEdit from './OrdPurchaseStickFeeEdit'
import copyMixin from '../../mixins/copyMixin'

export default {
  name: 'OrdPurchase',
  mixins: [copyMixin],
  components: {
    Pagination,
    DictSelect,
    DictTableColumn,
    DictTag,
    UserSelector,
    NoteColumn,
    OrderNotesDrawer,
    OrdPurchaseEdit,
    OrdPurchaseItemEdit,
    OrdPurchaseStickFeeEdit
  },
  data() {
    return {
      // 搜索表单数据
      formInline: {
        current: 1,
        size: 10,
        shopIds: [],
        orderSn: '',
        erpPlatform: '',
        orderStateList: ['001'], // 默认选中"待出货"状态
        purchaseChannel: '',
        purchaseUserIdList: [],
        purchaseDateStart: '',
        purchaseDateEnd: '',
        actualProfitLessThanZero: null,
        orderCreateTimeStart: '',
        orderCreateTimeEnd: '',
        orders: []
      },
      // 表格数据
      tableData: [],
      // 店铺列表
      shopList: [],
      // 订单状态列表
      orderStatusList: [],
      // 标签选项列表
      tagOptions: [],
      // 选中的用户列表
      selectedUsers: [],
      // 日期范围
      dateRange: [],
      // 下单日期范围
      orderDateRange: [],
      // 分页数据
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      // 展开的行
      expandedRows: [],

      // 采购订单对话框
      purchaseDialogVisible: false,
      currentPurchaseData: {},
      isEditPurchase: false,

      // 采购明细对话框
      purchaseItemDialogVisible: false,
      currentPurchaseItemData: {},
      isEditPurchaseItem: false,

      // 贴标费对话框
      stickFeeDialogVisible: false,
      currentStickFeeData: {},

      // 备注抽屉
      notesDrawerVisible: false,
      currentOrderNotes: [],
      currentOrderSn: '',
      currentScene: '01',  // 采购登记场景

      // 台湾提款手续费比例
      taiwanWithdrawFeeRatio: 1,

      // 倒计时定时器
      countdownTimer: null,
      // 当前时间戳（用于倒计时更新）
      currentTimestamp: Math.floor(Date.now() / 1000)
    }
  },
  computed: {
    // 获取当前登录用户ID
    currentUserId() {
      const userEntity = this.$store.getters.userEntity || JSON.parse(localStorage.getItem('userEntity') || '{}')
      return userEntity.userId || userEntity.id
    },

    // 检查是否有标签编辑权限
    hasTagEditPermission() {
      // 20250804. liwenchao 所有人都有标签权限
      return true;
      // const permissions = this.$store.getters.permissions || []
      // return permissions.includes('ord-purchase:update')
    }
  },
  created() {
    // 检查URL参数中是否有orderSn
    if (this.$route.query.orderSn) {
      this.formInline.orderSn = this.$route.query.orderSn
    }
    this.loadShops()
    this.loadOrderStates()
    this.loadSysParams()
    this.loadTagOptions()
    this.getPageData()
  },
  mounted() {
    // 启动倒计时定时器，每秒更新当前时间戳
    this.countdownTimer = setInterval(() => {
      this.currentTimestamp = Math.floor(Date.now() / 1000);
    }, 1000);
  },
  beforeDestroy() {
    // 清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    // 获取分页数据
    getPageData(parameter) {
      this.loading = true
      if (!parameter) {
        parameter = {
          current: this.formInline.current,
          size: this.formInline.size,
          shopIds: this.formInline.shopIds && this.formInline.shopIds.length > 0 ? this.formInline.shopIds : undefined,
          orderSn: this.formInline.orderSn || undefined,
          erpPlatform: this.formInline.erpPlatform || undefined,
          orderStateList: this.formInline.orderStateList && this.formInline.orderStateList.length > 0 ? this.formInline.orderStateList : undefined,
          purchaseChannel: this.formInline.purchaseChannel || undefined,
          purchaseUserIdList: this.formInline.purchaseUserIdList.length > 0 ? this.formInline.purchaseUserIdList : undefined,
          purchaseDateStart: this.formInline.purchaseDateStart || undefined,
          purchaseDateEnd: this.formInline.purchaseDateEnd || undefined,
          actualProfitLessThanZero: this.formInline.actualProfitLessThanZero,
          orderCreateTimeStart: this.formInline.orderCreateTimeStart || undefined,
          orderCreateTimeEnd: this.formInline.orderCreateTimeEnd || undefined,
          orders: this.formInline.orders
        }
      }

      getOrdPurchasePage(parameter)
        .then(res => {
          this.loading = false
          if (res.success && res.data) {
            this.tableData = res.data.records
            // 处理每个订单的采购总金额
            this.tableData.forEach(order => {
              // 调试信息
              console.log(`订单 ${order.orderSn}:`)
              console.log('- 后端返回的采购总金额:', order.totalPurchaseAmount)
              console.log('- 订单项数量:', order.orderItems ? order.orderItems.length : 0)
              if (order.orderItems && order.orderItems.length > 0) {
                console.log('- 订单项采购金额:', order.orderItems.map(item => item.purchaseAmount))
              }

              // 优先使用后端返回的采购总金额，如果没有则前端计算
              if (order.totalPurchaseAmount === undefined || order.totalPurchaseAmount === null) {
                this.calculateTotalPurchaseAmount(order)
                console.log('- 前端计算后的采购总金额:', order.totalPurchaseAmount)
              }
            })
            this.pageParam.currentPage = res.data.current
            this.pageParam.pageSize = res.data.size
            this.pageParam.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取数据失败：' + err.message)
        })
    },

    // 加载店铺数据
    loadShops() {
      getAllEnabledShops()
        .then(res => {
          if (res.success && res.data && res.data.records) {
            this.shopList = res.data.records
          }
        })
        .catch(err => {
          console.error('加载店铺数据失败：', err)
        })
    },

    // 加载订单状态数据
    loadOrderStates() {
      getOrderStates()
        .then(res => {
          if (res.success && res.data) {
            this.orderStatusList = res.data
          }
        })
        .catch(err => {
          console.error('加载订单状态数据失败：', err)
        })
    },

    // 加载系统参数
    loadSysParams() {
      sysParamGet().then(res => {
        if (res.success && res.data) {
          this.taiwanWithdrawFeeRatio = parseFloat(res.data.taiwanWithdrawFeeRatio) || 1
        }
      }).catch(err => {
        console.error('加载系统参数失败:', err)
        this.taiwanWithdrawFeeRatio = 1 // 默认值
      })
    },

    // 用户选择回调
    handleUserSelect(users) {
      this.selectedUsers = users
      this.formInline.purchaseUserIdList = users.map(user => user.userId)
    },

    // 分页回调
    callback_getPageData(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getPageData()
    },

    // 查询
    onSearch() {
      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.formInline.purchaseDateStart = this.dateRange[0]
        this.formInline.purchaseDateEnd = this.dateRange[1]
      } else {
        this.formInline.purchaseDateStart = ''
        this.formInline.purchaseDateEnd = ''
      }

      // 处理下单日期范围
      if (this.orderDateRange && this.orderDateRange.length === 2) {
        this.formInline.orderCreateTimeStart = this.orderDateRange[0]
        this.formInline.orderCreateTimeEnd = this.orderDateRange[1]
      } else {
        this.formInline.orderCreateTimeStart = ''
        this.formInline.orderCreateTimeEnd = ''
      }

      this.formInline.current = 1
      this.getPageData()
    },

    // 重置
    onReset() {
      this.formInline = {
        current: 1,
        size: 10,
        shopIds: [],
        orderSn: '',
        erpPlatform: '',
        orderStateList: ['001'], // 重置时默认选中"待出货"状态
        purchaseChannel: '',
        purchaseUserIdList: [],
        purchaseDateStart: '',
        purchaseDateEnd: '',
        actualProfitLessThanZero: null,
        orderCreateTimeStart: '',
        orderCreateTimeEnd: '',
        orders: []
      }
      this.selectedUsers = []
      this.dateRange = []
      this.orderDateRange = []
      this.getPageData()
    },

    // 获取行key
    getRowKey(row) {
      return row.orderSn
    },

    // 展开/折叠处理
    handleExpandChange(row, expandedRows) {
      this.expandedRows = expandedRows.map(r => r.orderSn)
    },



    // 编辑采购订单
    editPurchase(row) {
      this.currentPurchaseData = { ...row }
      this.isEditPurchase = true
      this.purchaseDialogVisible = true
    },

    // 编辑采购明细
    editPurchaseItem(row) {
      this.currentPurchaseItemData = { ...row }
      this.isEditPurchaseItem = true
      this.purchaseItemDialogVisible = true
    },

    // 删除采购明细
    deletePurchaseItem(row) {
      this.$confirm('确认删除该采购明细吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用删除API
        const deleteData = {
          idList: [row.id] // 使用订单明细ID
        }
        deleteOrdPurchaseItem(deleteData)
          .then(res => {
            if (res.success) {
              this.$message.success('删除采购明细成功')
              this.getPageData()
            } else {
              this.$message.error('删除失败：' + (res.message || '未知错误'))
            }
          })
          .catch(err => {
            this.$message.error('删除失败：' + err.message)
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 采购订单提交回调
    handlePurchaseSubmit() {
      this.purchaseDialogVisible = false
      this.getPageData()
    },

    // 编辑贴标费
    editStickFee(row) {
      this.currentStickFeeData = { ...row }
      this.stickFeeDialogVisible = true
    },

    // 贴标费提交回调
    handleStickFeeSubmit() {
      this.stickFeeDialogVisible = false
      this.getPageData()
    },

    // 采购明细提交回调
    handlePurchaseItemSubmit() {
      this.purchaseItemDialogVisible = false
      this.getPageData()
    },

    // 计算采购总金额
    calculateTotalPurchaseAmount(order) {
      if (!order.orderItems || order.orderItems.length === 0) {
        order.totalPurchaseAmount = null
        return
      }

      // 计算所有子项的采购金额之和
      let total = 0
      let hasPurchaseData = false

      order.orderItems.forEach(item => {
        // 只有当采购金额存在且有效时才计算
        if (item.purchaseAmount !== null && item.purchaseAmount !== undefined && item.purchaseAmount !== '') {
          const amount = parseFloat(item.purchaseAmount)
          if (!isNaN(amount)) {
            total += amount
            hasPurchaseData = true
          }
        }
      })

      // 如果没有采购数据，设置为null，显示为"-"
      order.totalPurchaseAmount = hasPurchaseData ? total : null
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    // 判断是否可以计算预计利润
    canCalculateExpectedProfit(row) {
      return row.incomeAmount != null && row.exchangeRate != null && row.expectWeight != null && row.totalPurchaseAmount !== null && this.taiwanWithdrawFeeRatio != null
    },

    // 获取实际利润公式显示
    getActualProfitFormula(row) {
      const incomeAmount = row.incomeAmount != null ? row.incomeAmount : '空'
      const taiwanWithdrawFeeRatio = this.taiwanWithdrawFeeRatio != null ? this.taiwanWithdrawFeeRatio : '空'
      const exchangeRate = row.exchangeRate != null ? row.exchangeRate : '空'
      const chargeWeight = row.chargeWeight != null ? row.chargeWeight : '空'
      const unitFee = row.chargeWeight != null && row.unitFee != null ? (row.unitFee / row.chargeWeight).toFixed(2) : '空'
      const stickFee = row.stickFee != null ? row.stickFee : '空'
      const inShopeeFee = row.inShopeeFee != null ? row.inShopeeFee : '空'
      const totalPurchaseAmount = row.totalPurchaseAmount != null ? row.totalPurchaseAmount : '空'
      const actualProfit = row.actualProfit !== null && row.actualProfit !== undefined ? row.actualProfit.toFixed(2) : '空'

      return `${incomeAmount} × ${taiwanWithdrawFeeRatio} ÷ ${exchangeRate} - ${chargeWeight} × ${unitFee} - ${stickFee} - ${inShopeeFee} - ${totalPurchaseAmount} = ${actualProfit}`
    },

    // 前端计算实际利润（贴标费不为空时，null值按0计算）
    calcFrontendActualProfit(row) {
      const incomeAmount = row.incomeAmount || 0
      const taiwanWithdrawFeeRatio = this.taiwanWithdrawFeeRatio || 1
      const exchangeRate = row.exchangeRate || 1
      const unitFee = row.unitFee || 0
      const stickFee = row.stickFee || 0
      const inShopeeFee = row.inShopeeFee || 0
      const totalPurchaseAmount = row.totalPurchaseAmount || 0
      return (incomeAmount * taiwanWithdrawFeeRatio) / exchangeRate - unitFee - stickFee - inShopeeFee - totalPurchaseAmount
    },

    // 前端实际利润公式显示（贴标费不为空时，null值显示为0）
    getFrontendActualProfitFormula(row) {
      const incomeAmount = row.incomeAmount != null ? row.incomeAmount : 0
      const taiwanWithdrawFeeRatio = this.taiwanWithdrawFeeRatio != null ? this.taiwanWithdrawFeeRatio : 0
      const exchangeRate = row.exchangeRate != null ? row.exchangeRate : 0
      const chargeWeight = row.chargeWeight != null ? row.chargeWeight : 0
      const unitFee = row.chargeWeight != null && row.unitFee != null ? (row.unitFee / row.chargeWeight).toFixed(2) : '0'
      const stickFee = row.stickFee != null ? row.stickFee : 0
      const inShopeeFee = row.inShopeeFee != null ? row.inShopeeFee : 0
      const totalPurchaseAmount = row.totalPurchaseAmount != null ? row.totalPurchaseAmount : 0
      const actualProfit = this.calcFrontendActualProfit(row).toFixed(2)
      return `${incomeAmount} × ${taiwanWithdrawFeeRatio} ÷ ${exchangeRate} - ${chargeWeight} × ${unitFee} - ${stickFee} - ${inShopeeFee} - ${totalPurchaseAmount} = ${actualProfit}`
    },

    // 前端计算实际利润率
    calcFrontendActualProfitRate(row) {
      const profit = row.stickFee != null ? this.calcFrontendActualProfit(row) : row.actualProfit
      if (!profit || !row.totalPrice || !row.exchangeRate) {
        return 0
      }
      const totalPriceInCny = row.totalPrice / row.exchangeRate
      return (profit / totalPriceInCny) * 100
    },

    // 获取预计每吨运费
    getExpectedUnitFee(row) {
      // 当实际重量、实际运费有值时，每吨运费 = unitFee / chargeWeight
      // 当实际重量、实际运费没有值时，每吨运费 = 11
      if (row.chargeWeight && row.unitFee) {
        return (row.unitFee / row.chargeWeight).toFixed(2)
      }
      return 11
    },

    // 获取预计贴标费
    getExpectedStickFee(row) {
      // 当实际重量、实际运费有值时，贴标费 = stickFee
      // 当实际重量、实际运费没有值时，贴标费 = 2
      if (row.chargeWeight && row.unitFee) {
        return row.stickFee || 0
      }
      return 2
    },

    // 获取预计进店费
    getExpectedInShopeeFee(row) {
      // 当实际重量、实际运费有值时，进店费 = inShopeeFee
      // 当实际重量、实际运费没有值时，进店费 = 2
      if (row.chargeWeight && row.unitFee) {
        return row.inShopeeFee || 0
      }
      return 2
    },



    // 计算预计利润
    calculateExpectedProfit(row) {
      if (!this.canCalculateExpectedProfit(row)) {
        return 0
      }

      // 新公式：入账金额 × 台湾提款手续费比例 ÷ 当日汇率 - 预计重量 × 每吨运费 - 贴标费 - 进店费 - 采购总金额 = 预计利润
      const incomeAmountWithFee = (row.incomeAmount || 0) * (this.taiwanWithdrawFeeRatio || 1)
      const incomeAmountInCny = incomeAmountWithFee / (row.exchangeRate || 1)
      const expectedWeight = row.expectWeight || 0
      const unitFee = this.getExpectedUnitFee(row)
      const stickFee = this.getExpectedStickFee(row)
      const inShopeeFee = this.getExpectedInShopeeFee(row)
      const totalPurchaseAmount = row.totalPurchaseAmount || 0

      return incomeAmountInCny - (expectedWeight * unitFee) - stickFee - inShopeeFee - totalPurchaseAmount
    },

    // 计算实际利润率
    calculateActualProfitRate(row) {
      if (!row.actualProfit || !row.totalPrice || !row.exchangeRate) {
        return 0
      }
      // 实际利润率 = 实际利润 ÷ (订单总金额 ÷ 当日汇率) × 100%
      const totalPriceInCny = row.totalPrice / row.exchangeRate
      return (row.actualProfit / totalPriceInCny) * 100
    },

    // 判断是否处于倒计时状态
    isCountdown(timestamp, orderStates) {
      if (!timestamp || orderStates !== '001') return false;
      const now = this.currentTimestamp;
      return timestamp > now;
    },

    // 格式化发货时间（支持倒计时）
    formatShipTime(timestamp, orderStates) {
      if (!timestamp) return '-';

      // 只有订单状态为"001"（待出货）时才显示倒计时
      if (orderStates !== '001') {
        return this.formatDateTime(timestamp);
      }

      const now = this.currentTimestamp;
      if (timestamp <= now) {
        // 已过期或倒计时为0，显示日期时间
        const date = new Date(timestamp * 1000);
        return date.getFullYear() + '-' +
          String(date.getMonth() + 1).padStart(2, '0') + '-' +
          String(date.getDate()).padStart(2, '0') + ' ' +
          String(date.getHours()).padStart(2, '0') + ':' +
          String(date.getMinutes()).padStart(2, '0');
      } else {
        // 未过期，显示倒计时
        const diff = timestamp - now;
        const days = Math.floor(diff / 86400);
        const hours = Math.floor((diff % 86400) / 3600);
        const minutes = Math.floor((diff % 3600) / 60);
        const seconds = diff % 60;
        return `${days}天${hours}时${minutes}分${seconds}秒`;
      }
    },

    // 格式化时间戳为日期时间字符串
    formatDateTime(timestamp) {
      if (!timestamp) return '-';
      const date = new Date(timestamp * 1000);
      return date.getFullYear() + '-' +
        String(date.getMonth() + 1).padStart(2, '0') + '-' +
        String(date.getDate()).padStart(2, '0') + ' ' +
        String(date.getHours()).padStart(2, '0') + ':' +
        String(date.getMinutes()).padStart(2, '0') + ':' +
        String(date.getSeconds()).padStart(2, '0');
    },

    // 处理排序变化
    handleSortChange(column) {
      if (column.order) {
        this.formInline.orders = [{
          column: column.prop,
          asc: column.order === 'ascending'
        }]
      } else {
        this.formInline.orders = []
      }
      this.getPageData()
    },

    // 打开备注抽屉
    openNotesDrawer(row) {
      this.currentOrderSn = row.orderSn
      this.currentOrderNotes = row.notes || []
      this.notesDrawerVisible = true
    },

    // 关闭抽屉
    handleDrawerClose() {
      this.notesDrawerVisible = false
      this.currentOrderNotes = []
    },

    // 处理备注更新事件
    handleNoteUpdated() {
      console.log('备注已更新，动态更新表格数据')

      // 不刷新整个页面，而是动态更新表格中的备注数据
      if (this.currentOrderSn) {
        // 延迟查询，确保后端数据已更新
        setTimeout(() => {
          // 查询该订单的备注（场景'01'）
          getByOrderSnAndScene({
            orderSn: this.currentOrderSn,
            scene: '01'
          }).then(res => {
            // 在表格数据中找到当前订单
            const orderIndex = this.tableData.findIndex(order => order.orderSn === this.currentOrderSn)
            if (orderIndex !== -1) {
              // 初始化notes数组（如果不存在）
              if (!this.tableData[orderIndex].notes) {
                this.$set(this.tableData[orderIndex], 'notes', [])
              }

              // 获取当前用户ID
              const userEntity = this.$store.getters.userEntity || JSON.parse(localStorage.getItem('userEntity') || '{}')
              const currentUserId = userEntity.id || userEntity.userId

              if (res.success && res.data) {
                // 有备注数据，更新或添加
                const existingNoteIndex = this.tableData[orderIndex].notes.findIndex(
                  note => note.scene === '01' && note.createUserId === currentUserId
                )

                if (existingNoteIndex !== -1) {
                  // 替换已有的备注
                  this.$set(this.tableData[orderIndex].notes, existingNoteIndex, res.data)
                } else {
                  // 添加新的备注
                  this.tableData[orderIndex].notes.push(res.data)
                }
              } else {
                // 没有备注数据，说明备注已被删除
                const filteredNotes = this.tableData[orderIndex].notes.filter(
                  note => !(note.scene === '01' && note.createUserId === currentUserId)
                )
                this.$set(this.tableData[orderIndex], 'notes', filteredNotes)
              }

              // 如果抽屉是打开状态，更新抽屉中的备注数据
              if (this.notesDrawerVisible) {
                this.currentOrderNotes = this.tableData[orderIndex].notes || []
              }

              console.log('备注已动态更新到表格')
            }
          }).catch(err => {
            console.error('查询备注失败:', err)
          })
        }, 200) // 延迟200ms确保后端数据已更新
      }
    },

    // 加载标签选项
    loadTagOptions() {
      dictCategoryItems({ categoryId: 'SCENE_01_TAG' })
        .then(res => {
          if (res.success && res.data) {
            // 标准化数据格式，确保有value和label字段
            this.tagOptions = res.data.map(item => ({
              value: item.itemValue || item.value,
              label: item.itemName || item.label || item.itemValue || item.value
            }))
          }
        })
        .catch(err => {
          console.error('加载标签选项失败：', err)
        })
    },

    // 判断标签是否已选中
    isTagSelected(row, tagValue) {
      if (!row.tagList || row.tagList.length === 0) {
        return false
      }
      return row.tagList.some(tag => tag.tag === tagValue)
    },

    // 添加标签
    addTag(row, tagValue) {
      if (this.isTagSelected(row, tagValue)) {
        return // 已经存在，不重复添加
      }

      // 获取当前标签列表
      const currentTags = row.tagList ? row.tagList.map(tag => tag.tag) : []
      const newTags = [...currentTags, tagValue]

      // 调用统一接口更新标签
      updateOrderTags(row.orderSn, '01', newTags)
        .then(res => {
          if (res.success) {
            this.$message.success('标签添加成功')
            this.getPageData() // 刷新表格数据
          } else {
            this.$message.error('添加失败：' + (res.message || '未知错误'))
          }
        })
        .catch(err => {
          this.$message.error('添加失败：' + err.message)
        })
    },

    // 删除标签
    removeTag(row, tagValue) {
      // 获取当前标签列表，移除指定标签
      const currentTags = row.tagList ? row.tagList.map(tag => tag.tag) : []
      const newTags = currentTags.filter(tag => tag !== tagValue)

      // 调用统一接口更新标签
      updateOrderTags(row.orderSn, '01', newTags)
        .then(res => {
          if (res.success) {
            this.$message.success('标签删除成功')
            this.getPageData() // 刷新表格数据
          } else {
            this.$message.error('删除失败：' + (res.message || '未知错误'))
          }
        })
        .catch(err => {
          this.$message.error('删除失败：' + err.message)
        })
    }

  }
}
</script>

<style scoped>
.content-container {
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 24px;
  margin-top: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}

.demo-form-inline {
  margin-bottom: 20px;
}

.demo-form-inline .el-form-item {
  margin-bottom: 10px;
}

/* 订单项展开区域样式 */
.order-items-section {
  background-color: #f8f9fa;
  border-radius: 6px;
}

.empty-table-placeholder {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}

/* 快递单号样式 */
.express-no {
  color: #67C23A;
  font-weight: bold;
  background-color: #F0F9FF;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #67C23A;
}

.no-express {
  color: #909399;
  font-style: italic;
}

.clickable-express {
  cursor: pointer;
  transition: all 0.2s;
}

.clickable-express:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

/* 商品名称复制样式 */
.clickable-item-name {
  cursor: pointer;
  transition: all 0.2s;
}

.clickable-item-name:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

/* 标签选择器样式 */
.tag-selector {
  max-width: 320px;
}

.tag-section {
  margin-bottom: 12px;
}

.tag-section:last-child {
  margin-bottom: 0;
}

.tag-section-title {
  font-size: 12px;
  color: #606266;
  margin-bottom: 6px;
  font-weight: 500;
}

.tag-options {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.tag-clickable {
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.tag-clickable:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

.tag-available:hover::after {
  content: '+';
  position: absolute;
  top: -2px;
  right: -2px;
  background: #67C23A;
  color: white;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.tag-selected {
  position: relative;
}

.tag-selected:hover::after {
  content: '×';
  position: absolute;
  top: -2px;
  right: -2px;
  background: #F56C6C;
  color: white;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.tag-display {
  min-height: 20px;
}

.editable-tag-display {
  cursor: pointer;
}

.editable-tag-display:hover {
  background-color: #f5f7fa;
  border-radius: 4px;
  padding: 2px;
}

.readonly-tag-display {
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/views/order/OrdPurchase.vue